<div class="min-h-screen-safe bg-westetics-neutral-100 flex flex-col">
  <!-- Cabeçalho -->
  <header class="bg-westetics-purple-800 text-white p-4 shadow-md">
    <div class="container mx-auto flex justify-center items-center">
      <img src="assets/icons/mini-logo-v2.svg" alt="Logo" class="h-8 w-8 object-contain brightness-0 invert mr-3">
      <h1 class="text-xl font-bold">Upload de Fotos do Produto</h1>
    </div>
  </header>

  <!-- Conteúdo principal -->
  <main class="flex-grow container mx-auto px-4 py-6">
    <!-- Indicador de carregamento -->
    <div *ngIf="loading" class="flex justify-center items-center py-12">
      <app-loading-spinner size="lg"></app-loading-spinner>
      <span class="ml-3 text-gray-700">Carregando...</span>
    </div>

    <!-- Conteúdo quando carregado -->
    <div *ngIf="!loading">
      <!-- Mensagem de erro -->
      <div *ngIf="errorMessage" class="mb-6 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i class="fas fa-exclamation-circle text-red-500"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Mensagem de sucesso -->
      <div *ngIf="uploadComplete" class="mb-6 bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-md">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i class="fas fa-check-circle text-green-500"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium">{{ successMessage }}</p>
            <p class="text-sm mt-1">Você pode fechar esta página agora. As fotos foram enviadas com sucesso!</p>
          </div>
        </div>
      </div>

      <!-- Instruções -->
      <div *ngIf="!uploadComplete" class="mb-6 bg-westetics-purple-100 px-4 py-4 rounded-md border border-westetics-purple-200">
        <h2 class="text-lg font-semibold mb-2">Instruções:</h2>
        <p class="text-sm text-gray-700 mb-4">
          Tire fotos dos seguintes itens para documentar o produto utilizado no tratamento:
        </p>
        <ul class="text-sm text-gray-700 mb-3 list-disc pl-5 space-y-1">
          <li>Frasco</li>
          <li>Caixa do Produto</li>
          <li>Etiqueta</li>
        </ul>
        <p class="text-sm text-gray-700">
          Selecione pelo menos uma foto para enviar. Você pode selecionar as fotos da sua galeria.
        </p>
      </div>

      <!-- Grid de fotos -->
      <div *ngIf="!uploadComplete" class="grid grid-cols-2 gap-4 mb-6">
        <div *ngFor="let photo of photos; let i = index" class="relative">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-sm font-medium">{{ photo.label }}</h3>
          </div>

          <!-- Visualização da foto selecionada ou existente -->
          <div *ngIf="photo.preview"
            class="relative bg-gray-50 border border-gray-200 rounded-xl flex flex-col justify-between overflow-hidden h-44 shadow-sm"
            (click)="selectPhoto(i)" [ngClass]="{'cursor-pointer': !photo.id}">
            <div class="flex-grow flex items-center justify-center p-2 min-h-0">
              <img [src]="photo.preview" alt="Foto {{ photo.label }}" class="max-w-full max-h-full object-contain">
            </div>

            <div *ngIf="!photo.id" class="p-2 border-t w-full bg-white">
              <button (click)="$event.stopPropagation(); removePhoto(photo)"
                class="w-full px-2 py-1.5 text-xs bg-red-600 text-white rounded hover:bg-red-700 flex items-center justify-center font-medium shadow-sm transition-colors">
                <i class="fas fa-trash mr-1.5"></i>
                Remover
              </button>
            </div>
          </div>

          <!-- Área para adicionar foto -->
          <div *ngIf="!photo.preview" (click)="selectPhoto(i)"
            class="bg-gray-100 rounded-xl flex items-center justify-center hover:bg-gray-200 h-44"
            [ngClass]="{'cursor-pointer': !photo.id}">
            <span class="text-gray-400 flex flex-col items-center">
              <i class="fas fa-plus text-2xl mb-1"></i>
              <span class="text-sm">Adicionar</span>
            </span>
          </div>
        </div>
      </div>

      <!-- Botões de ação -->
      <div *ngIf="!uploadComplete" class="flex flex-col gap-3">
        <button (click)="uploadPhotos()" [disabled]="!hasSelectedPhotos() || showUploadProgress" [ngClass]="{
          'bg-westetics-purple-800 hover:bg-westetics-purple-600': hasSelectedPhotos() && !showUploadProgress, 
          'bg-westetics-purple-300 cursor-not-allowed': !hasSelectedPhotos() || showUploadProgress
        }" class="w-full py-3 px-4 rounded-md text-white font-medium flex items-center justify-center">
          <span>{{ showUploadProgress ? 'Enviando...' : 'Enviar Fotos' }}</span>
        </button>

        <button *ngIf="hasSelectedPhotos() && !allPhotosSelected() && !loading"
          class="text-sm text-gray-500 mt-2 underline" (click)="uploadPhotos()">
          Enviar apenas as fotos selecionadas
        </button>
      </div>

      <!-- Botão para finalizar após upload completo -->
      <div *ngIf="uploadComplete" class="flex flex-col gap-3">
        <button (click)="finish()"
          class="w-full py-3 px-4 rounded-md bg-green-600 hover:bg-green-700 text-white font-medium flex items-center justify-center">
          <!-- <span>Concluído</span> -->
        </button>
      </div>
    </div>
  </main>

  <!-- Rodapé -->
  <footer class="bg-white border-t border-westetics-neutral-300 p-4">
    <div class="text-xs sm:text-sm text-westetics-neutral-600 text-center">
      © 2026 Westhetics. Todos os direitos reservados.
    </div>
  </footer>

  <!-- Overlay de processamento HEIC -->
  <div *ngIf="processingHeic" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-8 max-w-xs w-full shadow-xl flex flex-col items-center">
      <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
      <p class="text-sm text-gray-600">Processando imagem...</p>
    </div>
  </div>

  <!-- Modal para escolher entre câmera e galeria -->
  <div *ngIf="showCaptureOptions" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-xs w-full">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium">Escolha uma opção</h3>
        <button (click)="cancelCaptureOptions()" class="text-gray-500 hover:text-gray-700">
          <span class="text-xl">&times;</span>
        </button>
      </div>

      <div class="space-y-4">
        <button *ngIf="hasCamera" (click)="captureWithCamera()"
          class="w-full flex items-center p-4 bg-westetics-purple-100 hover:bg-westetics-purple-200 rounded-lg">
          <span class="bg-westetics-purple-200 p-2 rounded-full mr-3">
            <i class="fas fa-camera text-westetics-purple-800"></i>
          </span>
          <div class="flex flex-col items-start">
            <span class="font-medium">Usar câmera</span>
            <span class="text-xs text-gray-500">Abre a câmera nativa do dispositivo</span>
          </div>
        </button>

        <button (click)="selectFromGallery()"
          class="w-full flex items-center p-4 bg-westetics-bronze-100 hover:bg-westetics-bronze-200 rounded-lg">
          <span class="bg-westetics-bronze-200 p-2 rounded-full mr-3">
            <i class="fas fa-images text-westetics-bronze-600"></i>
          </span>
          <div class="flex flex-col items-start">
            <span class="font-medium">Escolher da galeria</span>
            <span class="text-xs text-gray-500">Selecione uma foto existente</span>
          </div>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showUploadProgress"
    class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">

      <h3 class="text-lg font-medium text-gray-900 mb-4">Enviando Fotos...</h3>

      <div class="mb-2">
        <div class="flex justify-between text-sm text-gray-600 mb-1">
          <span>Progresso Geral</span>
          <span>{{ filesUploaded }} / {{ totalFilesToUpload }}</span>
        </div>
        <div class="w-full bg-westetics-neutral-300 rounded-full h-2.5">
          <div class="bg-westetics-purple-800 h-2.5 rounded-full transition-all duration-300" [style.width.%]="uploadProgress">
          </div>
        </div>
      </div>

      <div class="mt-4 p-3 bg-gray-50 rounded-lg text-center">
        <p class="text-sm text-gray-600 mb-1">Enviando agora:</p>
        <p class="text-sm font-medium text-gray-800 truncate">{{ currentUploadingFileName }}</p>
      </div>

    </div>
  </div>
</div>